import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';

import content from 'assets/content/trade-in-modal.content.json';

import close from 'assets/images/general/close.svg';
import TradeInReq1 from 'assets/images/trade-in-req1.png';
import TradeInReq2 from 'assets/images/trade-in-req2.png';
import TradeInReq3 from 'assets/images/trade-in-req3.png';
import TradeInReq4 from 'assets/images/trade-in-req4.png';

import './TradeInReqModal.scss';

export default function TradeInReqModal({
    isOpen,
    onToggle
}) {
    const tradeInRequirements = [
        {
            id: 1,
            image: TradeInReq1,
            label: content?.REQUIREMENT_1
        },
        {
            id: 2,
            image: TradeInReq2,
            label: content?.REQUIREMENT_2
        },
        {
            id: 3,
            image: TradeInReq3,
            label: content?.REQUIREMENT_3
        },
        {
            id: 4,
            image: TradeInReq4,
            label: content?.REQUIREMENT_4
        }
    ];

    return (
        <Modal isOpen={isOpen} centered={true} toggle={onToggle}
            backdrop={true} className='trade-in-req-modal'>
            <div className='trade-in-req-modal__container'>
                <div className='w-100 trade-in-req-modal__container__header'>
                    <img className='ic-close' src={close} onClick={onToggle}
                        alt='Close' />
                </div>
                <div className='trade-in-req-modal__container__content'>
                    <p className='title'>{content?.REQUIREMENTS_TITLE}</p>
                    <div className='requirements'>
                        {tradeInRequirements.map((item) => (
                            <div className='requirements__req-tile' key={item?.id}>
                                <img className='image' src={item?.image} alt={item?.label}/>
                                <p className='desc'>{item?.label}</p>
                            </div>
                        ))}
                    </div>
                    <p className='note'>{content?.NOTE_1}</p>
                    <p className='note'>{content?.NOTE_2}</p>
                </div>
            </div>
        </Modal>
    );
}

TradeInReqModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func
};
